export default __webpack_public_path__ + "static/media/trending-card.3a758ca8.svg";